export const SET_ACTIVE_PROFILE = '[ActiveProfile] Set active profile';

export const SET_USER_TO_ACTIVE_PROFILE =
  '[ActiveProfile] Set user to active profile';
